import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

import ProcessDialogContent from './ProcessDialogContent';
import ProcessDialogFooter from './ProcessDialogFooter';
import ProcessDialogHeader from './ProcessDialogHeader';
import ProcessDialogRoot from './ProcessDialogRoot';
import type { ProcessDialogContentVariant } from './types';

export interface ProcessDialogSimpleProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  headerActions?: ReactNode;
  showFooter?: boolean;
  contentVariant?: ProcessDialogContentVariant;
  contentPadding?: number | string;
}

export const ProcessDialogSimple: React.FC<ProcessDialogSimpleProps> = ({
  open,
  onClose,
  title,
  children,
  headerActions,
  showFooter = true,
  contentVariant,
  contentPadding,
}) => {
  return (
    <ProcessDialogRoot open={open} onClose={onClose}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <ProcessDialogHeader
          title={title}
          onClose={onClose}
          actions={headerActions}
        />
        <ProcessDialogContent variant={contentVariant} padding={contentPadding}>
          {children}
        </ProcessDialogContent>
        {showFooter && <ProcessDialogFooter />}
      </Box>
    </ProcessDialogRoot>
  );
};
